import { Paper, alpha, styled } from '@mui/material';
import imageBackgroundMobile from 'assets/img/background-phone.png';
import imageBackground from 'assets/img/background.png';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  textAlign: 'center',
  flexGrow: 1,

  [theme.breakpoints.up('sm')]: {
    textAlign: 'unset',
  },
}));

export const PaperStyled = styled(Paper)(({ theme }) => ({
  backgroundColor: `linear-gradient(180deg, ${theme.palette.primary[100]}, ${theme.palette.primary[50]})`,
  background: theme.palette.primary.dark,
  backgroundImage: `url(${imageBackgroundMobile})`,
  backgroundPosition: 'bottom right',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '60%',

  [theme.breakpoints.up('sm')]: {
    backgroundImage: `url(${imageBackground})`,
    backgroundSize: 'contain',
  },
}));

export const Body = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  gap: '2rem',
}));

export const Image = styled('img')(() => ({
  maxWidth: '13.5rem',
  width: '50%',
}));

export const Info = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '1rem',
  background: alpha(theme.palette.primary.main, 0.9),
  padding: '2rem',
  maxWidth: '31rem',
  width: '100%',
  gap: '1rem',
}));

export const TextAlign = styled('div')(({ theme }) => ({
  color: theme.palette.secondary.light,
  display: 'flex',
  gap: '1rem',
}));

export const TextAlignColumn = styled('div')(({ theme }) => ({
  color: theme.palette.secondary.light,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
}));

export const TextGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.secondary.light,
}));
